import { getError } from 'Domain/Mesh/Provider/ErrorProvider'
import { ihm_viewer__dictionary, locale } from '../../../Application/i18n/i18nViewer'

/*****************************************************************
 * Error Handler
 * ***************************************************************/

/**
 * Retrieve error panel
 * @param {number} errorCode 
 * @returns object
 */
export const getObject = errorCode => getError( 
        ihm_viewer__dictionary[errorCode][locale()].content, 
        ihm_viewer__dictionary[errorCode][locale()].title 
    )
